export function processWpPost(content) {
  content = typeof(content) === "string"
    ? content
    : "";

  content = content.trim();
  content = content.replace(/\n{4}/g, "<br/>");
  return content;
}
